import { HttpErrorResponse, HttpInterceptorFn } from "@angular/common/http";
import { inject } from "@angular/core";
import { Router } from "@angular/router";
import { catchError, throwError } from "rxjs";
import { AuthService } from "../services/auth.service";

/**
 * Auth interceptor for cookie-based authentication.
 * - Sets withCredentials: true on all requests
 * - Handles 401 responses by redirecting to login
 * - No token refresh needed (handled by backend cookies)
 */
export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // Always include credentials (cookies) with requests
  const cloned = req.clone({
    withCredentials: true,
  });

  return next(cloned).pipe(
    catchError((error: unknown) => {
      // Don't intercept 401s from auth endpoints (login/refresh)
      if (
        error instanceof HttpErrorResponse &&
        error.status === 401 &&
        !req.url.includes("/api/v1/auth/")
      ) {
        authService.handleUnauthorized();
        void router.navigate(["/login"], {
          queryParams: { reason: "session-expired" },
        });
      }

      return throwError(() => error);
    }),
  );
};
